<template>
    <v-main v-if="org">
        <v-container fluid>
            <v-card>
                <v-card-title class="title font-weight-light">
                    <v-icon large>{{$store.state.icons.dashboard}}</v-icon> Dashboard
                </v-card-title>
                <v-card-text  class="headline">
                    <v-row>
                        <v-col cols="12" sm="4" >
                            <v-card outlined >
                                <v-card-text>
                                    <div>
                                        <img :src="org.info.small_logo" height="50" />
                                    </div>
                                    <div>
                                        <span class="awesome--text title font-weight-light">{{org.info.fullname}}</span>
                                    </div>
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col cols="12" sm="5">
                            <v-card outlined v-if="$store.state.org.contactsdata" >
                                <v-card-text>
                                    <div>
                                        <img src="@/assets/navicons/contact.svg" height="50" />
                                    </div>
                                    <div>
                                        <span class="awesome--text title font-weight-light">Active Contacts:</span>
                                        <span class="awesome--text title font-weight-light">{{$store.state.org.contactsdata.active}}</span>
                                    </div>
                                    <div>
                                        <span class="awesome--text title font-weight-light">Archived Contacts:</span>
                                        <span class="awesome--text title font-weight-light">{{$store.state.org.contactsdata.archived}}</span>
                                    </div>
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col sm="3">
                            <v-card outlined >
                                <v-card-text>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="4" >
                            <v-card outlined color="grey lighten-3">
                                <v-card-text>Month Stats</v-card-text>
                                <BarChart  :height="200" :chartData="monthsdata" />
                            </v-card>
                        </v-col>
                        <v-col cols="12" sm="4" >
                            <v-card outlined color="grey lighten-3" >
                                <v-card-text>Top Contacted</v-card-text>
                                <BarChart  :height="200" :chartData="favsdata" />
                            </v-card>
                        </v-col>
                        <v-col cols="12" sm="4" >
                            <v-card outlined color="grey lighten-3" >
                                <v-card-text>Top Links</v-card-text>
                                <BarChart  :height="200" :chartData="favlinks" v-if="favlinks" />
                            </v-card>
                        </v-col>
                        <v-col cols="12" class="py-0">
                            <span class="headline font-weight-light">Web Properties</span>
                            <v-select
                                    :items="mytokens"
                                    small
                                    item-text="token"
                                    item-value="token"
                                    label="WebProps"
                                    @change="getTokenData($event)"
                                    block
                            ></v-select>
                        </v-col>
                        <v-col cols="12"  >
                            <v-card outlined color="grey lighten-3" >
                                <v-card-text>Website Hits</v-card-text>
                                <LineChart :height="200" :chartData="tokendata" v-if="tokendata" />
                            </v-card>
                            <v-card v-if="1===2" outlined color="grey lighten-3" >
                                    <v-card-text>Registrations</v-card-text>
                                    <BarChart :height="400" :chartData="divdata" v-if="divdata" />
                            </v-card>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <BaseBtn text to="/">Home</BaseBtn>
                </v-card-actions>
            </v-card>
        </v-container>
    </v-main>
</template>

<script>
  //SET UP EMAIL ADDRESS FORWARDER FOR TEST-REGISTRATION OF TEXTAPPY...
  //CREATE SMSCONFIRMER
  import {
    mapState,
    mapActions
  } from 'vuex'
  import BaseBtn from "@/components/BaseBtn";
  import BarChart from "@/components/charts/BarChart";
  import LineChart from "@/components/charts/LineChart";
  export default {
    components: {LineChart, BarChart, BaseBtn},
    name: "DashboardC",
    data() {
      return {
        twiliosubaccount:false,
        monthtotals: {ct:0,sm:0},
        monthsdata:{
          labels: [],
          datasets: [
            {
              //label: 'Month to date ',
              backgroundColor: '#424242',
              data: []
            }
          ]
        },
        favsdata:{
          labels: [],
          datasets: [
            {
              //label: 'Month to date ',
              backgroundColor: '#424242',
              data: []
            }
          ]
        },
        favlinks:undefined,
        tokendata:undefined,
        divdata:undefined,
        mytokens:[],
        activetoken:undefined,
        loadingtoken:undefined
      }
    },
    computed:{
      ...mapState(['icons','org','loggedin']),
      barscount(){
        return (this.$vuetify.breakpoint.smAndDown)?5:10
      }
    },
    watch:{
      loggedin(n){
        if(n){
          this.getData
        }
      },
      org(n){
        return n;
      }
    },
    mounted() {
      this.getMonthTotals()
      this.getMyFavs()
      this.getTopLinks()
      this.getMyTokens()
      this.getRegistrations()
    },
    methods: {
      ...mapActions(['get','post']),
      async getMonthTotals(){
        let t = await this.get({path:'api/smsdata/totals/monthtotals'})
        console.log('T',t)
        let d = t.pop()
        this.monthsdata = {
          labels: ['Sms Sent', 'Credits Used', 'Totals Available'],
          datasets: [
            {
              label: 'Monthly Sending Statistics',
              backgroundColor:  ['green','yellow','red'],
              data: [d.ct,d.sm,2000],
              borderColor: ['green','yellow','red'],
              borderWidth: 2
            }
          ]
        }
      },
      async getMyFavs(){
        let t = await this.get({path:'api/smsdata/totals/myfavs'})
        console.log('T',t)
        this.processForBar(t.slice(0,this.barscount),'favsdata','#0f2944')
      },
      async getTopLinks(){
        let t = await this.get({path:'api/smsdata/totals/favlinks'})
        console.log('T',t)
        this.processForBar(t,'favlinks','green')
      },
      async getTokenData(tk){
        this.loadingtoken = tk
        this.activetoken =  tk
        let t = await this.get({path:'api/smsdata/totals/tokentrack-'+tk})
        console.log('T',t)
        t.reverse()
        this.loadingtoken = false
        this.processForBar(t,'tokendata','purple')
      },
      async getMyTokens(){
        this.mytokens = await this.get({path:'api/smsdata/totals/mytokens'})
        if(this.mytokens.length===1){
          this.getTokenData(this.mytokens[0].token)
        }
      },
      async getRegistrations(){
        let t = await this.get({path:'api/smsdata/tournaments/divcounts'})
        console.log('T REG',t)
        t.reverse()
        this.loadingtoken = false
        this.processForRegBar(t,'divdata')
      },      

      processForBar(rawdata, setname, color){
        let labels = []
        let data = []
        rawdata.forEach(r=>{
          labels.push(r.name)
          data.push(r.ct)
        })
        this[setname] = {
          labels: labels,
          datasets: [
            {
              label: 'Top Data',
              backgroundColor: color,
              data: data,
              borderColor: '#ffffff'
            }
          ]
        }
      },

      processForRegBar(rawdata, setname){
        let labels = []
        let data = []
        let data2 = []
        rawdata.forEach(r=>{
          labels.push(r.name)
          data2.push(r.cap)
          data.push(r.ct)
        })
        this[setname] = {
          labels: labels,
          datasets: [
            {
              label: 'Div Count',
              backgroundColor: 'red',
              data: data,
              borderColor: '#ffffff'
            },
            {
              label: 'Div Cap',
              backgroundColor: 'green',
              data: data2,
              borderColor: '#ffffff'
            }

          ]
        }


      },

    }
  }
</script>

<style scoped>

</style>